import { STUDIO_TOOLS, studioTool } from '@ads/shared';
import { useNavigate } from 'react-router';
import * as Ic from '../components/icons';
import { Actions, useViewMeta } from '../components/Shell';
import { PREVIEWS } from '../components/studioArt';
import { dateTime } from '../lib/format';
import { useArtifacts, useSites } from '../lib/queries';
import { ViewSkeleton } from '../components/Skeleton';

export function Biblioteca() {
  useViewMeta({ nav: 'biblioteca', crumb: ['Biblioteca', 'Peças geradas'], j: .9 });
  const nav = useNavigate();
  const q = useArtifacts();
  const list = q.data ?? [];
  const sites = useSites();
  const live = new Map((sites.data ?? []).filter(s => s.url && s.publication?.status === 'done' && s.artifactId).map(s => [s.artifactId!, s]));

  return (
    <section className="view on" data-v="biblioteca">
      <div className="vhead">
        <div>
          <div className="eyebrow"><span className="rule" /><span>Biblioteca</span><b>{list.length} peça{list.length === 1 ? '' : 's'}</b></div>
          <h1>Biblioteca</h1>
          <p className="lede">Tudo o que o Studio produziu. Peça pronta continua aberta: <b className="strong">edite com o agente</b> — peça ajustes, envie fotos, volte versões e publique de novo. Cada peça guarda a versão do DNA e do design system que a gerou.</p>
        </div>
      </div>

      {q.isPending && <ViewSkeleton cards={3} />}
      {q.isSuccess && !list.length && (
        <div className="empty-state">
          <div className="pv-frame small"><svg viewBox="0 0 240 180" dangerouslySetInnerHTML={{ __html: PREVIEWS.plan }} /></div>
          <b>Nenhuma peça ainda.</b>
          <p>Abra uma bancada no Studio e gere a primeira.</p>
        </div>
      )}

      <div className="lib">
        {list.map((a, i) => {
          const t = STUDIO_TOOLS.find(x => x.key === a.tool) ?? studioTool('plan');
          const site = live.get(a.id);
          /* o site no ar ficou para trás: a conversa criou versões depois da publicação */
          const behind = !!site && site.publication?.revision != null && a.revision > site.publication.revision;
          return (
            <div key={a.id} className="lib-item" data-status={a.status} style={{ ['--i' as string]: i }}>
              <button type="button" className="lib-open" aria-label={`Abrir ${a.title}`} onClick={() => nav(`/pecas/${a.id}`)} />
              <span className="lib-th"><svg viewBox="0 0 240 180" dangerouslySetInnerHTML={{ __html: PREVIEWS[a.tool] ?? PREVIEWS.plan }} /></span>
              <span className="lib-tx">
                <span className="lib-no">{t.no}<em>{t.name}</em></span>
                <b>{a.title}</b>
                <span className="lib-meta">
                  <span>{dateTime(a.createdAt)}</span>
                  {a.createdBy && <span>{a.createdBy}</span>}
                  <span>{a.blocks} blocos</span>
                  {a.revision > 1 && <span title="Versões criadas na conversa com o agente">versão {a.revision}</span>}
                  <span className={`lib-st ${a.status}`}>{a.status === 'ready' ? 'Pronta' : a.status === 'failed' ? 'Falhou' : 'Gerando…'}</span>
                  {site && <span className="lib-st live" title={site.url!}>No ar · {site.slug}{site.publication?.revision ? ` · v${site.publication.revision}` : ''}</span>}
                  {behind && <span className="lib-st pend" title="A peça mudou na conversa depois da última publicação">Alterações fora do ar</span>}
                </span>
              </span>
              {a.status === 'ready' && (
                <button type="button" className="lib-edit" onClick={() => nav(`/pecas/${a.id}?conversa=1`)} title="Abrir a conversa com o agente desta peça">
                  <Ic.Sparkle />Editar com IA
                </button>
              )}
              <Ic.ChevronRight className="lib-go" />
            </div>
          );
        })}
      </div>

      <Actions>
        <button className="btn-primary" type="button" onClick={() => nav('/studio')}>Abrir o Studio<Ic.ArrowRight /></button>
      </Actions>
    </section>
  );
}
